<template>
  <div
    class="c-checkbox"
    v-on:click="
      checkedState = !checkedState;
      $emit('check', checkedState ? trueValue : falseValue);
    "
    v-bind:class="{ 'c-checkbox--checked': checkedState }"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
      <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
    </svg>
    <input
      type="checkbox"
      v-on:check="
        checkedState = !checkedState;
        $emit('check', checkedState ? trueValue : falseValue);
      "
      :id="labelLink"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      checkedState: false,
    };
  },
  props: {
    checked: {
      default: false,
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
    labelLink: {
      default: false,
    },
  },
  watch: {
    checked() {
      this.checkedState = this.checked;
    },
  },
};
</script>
<style lang="scss">
@import "../_variables.scss";
.c-checkbox {
  width: 18px;
  height: 18px;
  border: 1px solid $darkGray;
  background-color: $white;
  display: inline-block;
  margin-right: 0.5rem;
  cursor: pointer;
  position: relative;
  &:hover {
    border: 1px solid $green;
  }
  input {
    opacity: 0;
    position: absolute;
  }
  svg {
    fill: #fff;
    margin-bottom: 4px;
    margin-left: 1px;
    opacity: 0;
    transition: opacity 0.5s;
  }
  &--checked {
    background: $green;
    border: 1px solid $green;
    svg {
      opacity: 1;
    }
  }
}
</style>
